<template>
  <div>
    <list type="outputs"></list>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from '../BottomSheet'
import List from './List'
export default {
  components: {
    BottomSheet,
    List
  }
}
</script>